import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import * as he from 'he';
import { ActivatedRoute } from '@angular/router';
import { Carousel } from 'primeng/carousel';
import { ProductService } from 'src/services/productservice';
import { DomSanitizer, SafeResourceUrl, SafeUrl, Title } from '@angular/platform-browser';
import { AuthenticationService } from '@app/auth';
import { Subscription } from 'rxjs';
import { Meta } from '@angular/platform-browser';
import { environment } from '@env/environment';

@Component({
  selector: 'app-high-lights-details',
  templateUrl: './high-lights-details.component.html',
  styleUrls: ['./high-lights-details.component.scss'],
  providers: [],
})
export class HighLightsDetailsComponent implements OnInit, OnDestroy {
  view_node: any;
  nodeid: any;
  images: any = [];
  crowdriff_images: any = [];

  highLights: any = {
    imgCredit: '',
    imgCaption: '',
    bannerTitle: null,
    bannerContent: null,
    bannerImage: null,
    gallery: [{ url: null }],
    moreImages: [],
    moreVideos: [{ url: null }],
  };
  likesData: any = { is_user_liked: null, like_count: 0, liked_nid: 0 };
  specialIntersetIcon: SafeUrl;
  specialInterestName: string = '';
  createdBy: string;
  like: boolean = false;
  likeError: boolean = false;
  userid: any = '';
  nid: any = '';
  subscription1$: Subscription;
  subscription2$: Subscription;
  subscription3$: Subscription;
  subscription4$: Subscription;
  subscriptions: Subscription[] = [];
  responsiveOptions: any;
  lang: any;
  shareData: any;
  activeIndex: any;
  activeIndexc: any;
  displayCustomc: boolean;
  displayCustom: boolean;

  public imageDisplayCustom: boolean;
  public imageActiveIndex: number = 0;
  public galleryDisplayCustom: boolean;
  public galleryActiveIndex: number = 0;

  constructor(
    private authenticationService: AuthenticationService,
    private route: ActivatedRoute,
    private productService: ProductService,
    private titleService: Title,
    private sanitizer: DomSanitizer,
    private meta: Meta
  ) {
    Carousel.prototype.onTouchMove = () => {};
    this.responsiveOptions = [
      {
        breakpoint: '1024px',
        numVisible: 3,
        numScroll: 1,
      },
      {
        breakpoint: '768px',
        numVisible: 2,
        numScroll: 1,
      },
      {
        breakpoint: '640px',
        numVisible: 2,
        numScroll: 1,
      },
      {
        breakpoint: '480px',
        numVisible: 1,
        numScroll: 1,
      },
    ];
  }

  ngOnInit(): void {
    this.lang = localStorage.getItem('language');
    this.subscription1$ = this.authenticationService.currentUser.subscribe((user: any) => {
      if (user && user.current_user) {
        this.userid = user.current_user.uid;
        this.likeError = false;
        this.getLikeDetails();
      } else {
        this.userid = '';
        this.getLikesDetailsWithoutLogin();
      }
    });
    this.subscription2$ = this.route.paramMap.subscribe((paramMap) => {
      this.nodeid = paramMap.get('nodeid');
      this.view_node = paramMap.get('view_node');
      this.getDetails();
    });
    this.subscriptions.push(this.subscription1$);
    this.subscriptions.push(this.subscription2$);
  }

  likeClick() {
    if (this.userid == '') {
      this.likeError = true;
      setTimeout(() => {
        this.like = false;
      }, 2000);
      return;
    } else {
      let value = '0';
      let type = 'post';
      if (this.likesData.liked_nid != 0) {
        type = 'patch';
      }

      if (this.likesData.liked_nid == 0) {
        value = '1';
      } else if (this.likesData.liked_nid != 0 && this.likesData.is_user_liked != '1') {
        value = '1';
      }
      const json = {
        title: [{ value: this.highLights.bannerTitle }],
        type: [{ target_id: 'dw_like' }],
        field_user_id: [{ value: this.userid }],
        field_node_id: [{ value: this.nid.toString() }],
        field_like: [{ value: value }],
      };
      this.subscription3$ = this.productService
        .updateLikesCount(json, type, this.likesData.liked_nid)
        .subscribe((data) => {
          this.getLikeDetails();
        });
      this.subscriptions.push(this.subscription3$);
    }
  }
  closePopup() {
    this.likeError = false; // Close the popup
  }
  modifyUri(originalUri: string): string {
    // Add your logic to modify the URI here// For example, replacing a part of the path
    return originalUri.replace(environment.imageOldBlogDetail, environment.imageNewurl);
  }

  getLikesDetailsWithoutLogin() {
    if (this.nid === '') return;
    this.productService.getLikesCountWithoutLogin(this.nid).then((likesdata: any) => {
      this.updateLikeButtonStatus(likesdata);
    });
  }

  getLikeDetails() {
    if (this.nid === '') return;
    this.productService.getLikesCount(this.nid, this.userid).then((likesdata: any) => {
      this.updateLikeButtonStatus(likesdata);
      this.subscription4$ = this.productService
        .updateLikesHighlightCount(this.nid, likesdata.like_count)
        .subscribe((data) => {});
      this.subscriptions.push(this.subscription4$);
    });
  }

  updateLikeButtonStatus(likesdata: any) {
    this.likesData = likesdata;
    if (this.likesData.is_user_liked == '1') {
      this.like = true;
    } else {
      this.like = false;
    }
  }

  getDetails() {
    this.productService.getHighLightsBlobDetails(this.nodeid, this.view_node).then((data) => {
      let modifiedUri = this.modifyUri(data.bannerImage);
      if (data.metaTitle) {
        this.meta.updateTag({ name: 'title', content: data.metaTitle });
        this.titleService.setTitle(data.metaTitle);
      }
      if (data.metaKeywords) {
        this.meta.updateTag({ name: 'keywords', content: data.metaKeywords });
      }
      if (data.metaDescription) {
        this.meta.updateTag({ name: 'description', content: data.metaDescription });
      }
      data = {
        ...data,
        bannerImage: modifiedUri,
      };
      if (data.bannerContent) {
        data.bannerContent = this.decodeHtmlEntities(data.bannerContent);
        data.bannerContent = data.bannerContent.replace(/<a\s+href=["'][^"']*["']/g, (match: string) => {
          return match.includes('target=') ? match : match + ' target="_blank"';
        });
      }

      if (data.description_2) {
        data.description_2 = this.decodeHtmlEntities(data.description_2);
        data.description_2 = data.description_2.replace(/<a\s+href=["'][^"']*["']/g, (match: string) => {
          return match.includes('target=') ? match : match + ' target="_blank"';
        });
      }

      if (data.relatedBlogs && data.relatedBlogs.length > 0) {
        data.relatedBlogs.map((item: any) => {
          item.title = item.title.replace('&#039;', "'");
          if (item.field_blog_category) {
            let specialIntrest = item.field_blog_category.toLowerCase();
            specialIntrest = specialIntrest.replace(/&amp;/g, '&');
            switch (specialIntrest) {
              case 'things to do':
                item.specialInterestName = 'Things to do';
                item.specialIntersetIcon = 'icon-icons8-scuba-mask-50';
                break;
              case 'focus':
                item.specialInterestName = 'Focus';
                item.specialIntersetIcon = 'icon-icons8-sail-boat-50';
                break;
              case 'sustainability':
                item.specialInterestName = 'Sustainability';
                item.specialIntersetIcon = 'icon-icons8-fishing-50';
                break;
              case 'travel tips':
                item.specialInterestName = 'Travel Tips';
                item.specialIntersetIcon = 'icon-icons8-home-office-50';
                break;
              case 'romance':
                item.specialInterestName = 'Romance';
                item.specialIntersetIcon = 'icon-icons8-romance-50';
                break;
              case 'nature & wildlife':
                item.specialInterestName = 'Nature & Wildlife';
                item.specialIntersetIcon = 'icon-icons8-leaf-50';
                break;
              case 'culture':
                item.specialInterestName = 'Culture';
                item.specialIntersetIcon = 'icon-icons8-romance-50';
            }
          }
        });
      }
      switch (data.specialInterest) {
        case 'things to do':
          data.specialInterestName = 'Things to do';
          data.specialIntersetIcon = 'icon-icons8-scuba-mask-50';
          break;
        case 'focus':
          data.specialInterestName = 'Focus';
          data.specialIntersetIcon = 'icon-icons8-sail-boat-50';
          break;
        case 'sustainability':
          data.specialInterestName = 'Sustainability';
          data.specialIntersetIcon = 'icon-icons8-fishing-50';
          break;
        case 'travel tips':
          data.specialInterestName = 'Travel Tips';
          data.specialIntersetIcon = 'icon-icons8-home-office-50';
          break;
        case 'romance':
          data.specialInterestName = 'Romance';
          data.specialIntersetIcon = 'icon-icons8-romance-50';
          break;
        case 'nature & wildlife':
          data.specialInterestName = 'Nature & Wildlife';
          data.specialIntersetIcon = 'icon-icons8-leaf-50';
          break;
        case 'culture':
          data.specialInterestName = 'Culture';
          data.specialIntersetIcon = 'icon-icons8-romance-50';
          break;
      }
      if (data.moreVideos && data.moreVideos.length) {
        data.moreVideos.forEach((video: any) => {
          video.embedUrl = video.url && this.isYoutubeVideoUrl(video.url) ? this.formatYoutubeUrl(video.url) : '';
        });
      }
      this.highLights = data;
      this.images.push(this.highLights.bannerImage);
      this.titleService.setTitle(this.highLights.bannerTitle + ' ' + '| The Seychelles Islands');
      let browserUrl = 'https://www.seychelles.com/home';
      let image = 'https://www.seychelles.com/assets/images/favicons/favicon-192x192.png';
      if (location.href.indexOf('localhost') >= 0 || location.href.indexOf('staging') >= 0) {
        browserUrl = 'https://staging.seychelles.com/home';
        image = 'https://staging.seychelles.com/assets/images/favicons/favicon-192x192.png';
      }

      if (
        this.highLights.field_crowdriff_gallery_details &&
        this.highLights.field_crowdriff_gallery_details !== null &&
        this.highLights.field_crowdriff_gallery_details !== ''
      ) {
        if (this.highLights.field_crowdriff_gallery_details.data) {
          this.crowdriff_images = this.highLights.field_crowdriff_gallery_details.data;

          this.crowdriff_images = Object.keys(this.crowdriff_images).map((key) => ({
            value: this.crowdriff_images[key],
          }));
          this.crowdriff_images.forEach((item: any) => {
            item.value['userName'] = '';
            if (item.value.user.full_name != '') {
              item.value['userName'] = item.value.user.full_name;
            } else if (item.value.user.screen_name != '') {
              item.value['userName'] = item.value.user.screen_name;
            }
          });
        }
      }

      this.shareData = {
        tags: '',
        via: '',
        url: browserUrl,
        href: window.location.href,
        image: image,
        title: 'Seychelles Travel - Official Tourism Website of the Seychelles', //'I’ve found a beautiful ' + catType + ' ' + this.listingDetails.productName + ' in Seychelles',
        description:
          'Be inspired. Experience all that the Seychelles Islands has to offer from our pristine waters, to our exquisite flora and fauna.',
        // 'Hi,\n\nI’ve found a beautiful ' +
        // catType +
        // ' ' +
        // this.listingDetails.productName +
        // ' in Seychelles. \n\nCheck it out: ' +
        // browserUrl +
        // '.\n\nThanks\n\n',
      };
      // this.meta.addTag({ property: 'og:image', content: this.highLights.bannerImage });
      // this.meta.addTag({
      //   property: 'og:title',
      //   content: 'Beautiful blog ' + this.highLights.bannerTitle + ' in Seychelles',
      // });
      // this.meta.addTag({
      //   property: 'og:description',
      //   content: 'Beautiful blog ' + this.highLights.bannerTitle + ' in Seychelles',
      // });
      // this.meta.addTag({ property: 'og:url', content: location.href });
      // this.meta.addTag({ property: 'og:type', content: 'website' });
      // this.meta.addTag({ property: 'twitter:card', content: 'photo' });
      // this.meta.addTag({ property: 'twitter:site', content: '@seychelles' });
      // this.meta.addTag({ property: 'twitter:url', content: location.href });
      // this.meta.addTag({
      //   property: 'twitter:title',
      //   content: 'Beautiful blog ' + this.highLights.bannerTitle + ' in Seychelles',
      // });
      // //this.meta.addTag({ property: 'og:description', content: this.highLights.bannerContent });
      // this.shareData = {
      //   tags: '',
      //   via: '',
      //   url: location.href,
      //   image: this.highLights.bannerImage,
      //   title: 'I’ve found a beautiful blog in Seychelles',
      //   description:
      //     'Hi,\n\nI’ve found a beautiful blog ' +
      //     this.highLights.bannerTitle +
      //     ' in Seychelles. \n\nCheck it out: ' +
      //     location.href +
      //     '.\n\nThanks\n\n',
      // };
      if (data.nid && data.nid != '') {
        this.nid = data.nid;
        if (this.userid != '') {
          this.getLikeDetails();
        } else {
          this.getLikesDetailsWithoutLogin();
        }
      }
      setTimeout(() => {
        ($('#secondary-images-container') as any)
          .imagesLoaded(function () {
            ($('.secondary-image') as any).masonry({
              itemSelector: '.secondary-image-item',
            });
          })
          .progress(function (instance: any, image: any) {
            var result = image.isLoaded ? 'loaded' : 'broken';
          });
        ($('#secondary-gallery-container') as any)
          .imagesLoaded(function () {
            ($('.secondary-gallery') as any).masonry({
              itemSelector: '.secondary-gallery-item',
            });
          })
          .progress(function (instance: any, image: any) {
            var result = image.isLoaded ? 'loaded' : 'broken';
          });
      }, 500);
    });
  }
  // For remove HTML entities such as &lt; and &amp;
  decodeHtmlEntities(input: string): string {
    return he.decode(input);
  }

  isYoutubeVideoUrl(videoURL: string) {
    const isYoutubeUrl = /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S*)?$/;
    return isYoutubeUrl.exec(videoURL) !== null;
  }

  formatYoutubeUrl(videoURL: string): SafeResourceUrl {
    const sharedFormatUrl = /^https:\/\/youtu\.be\/(\S+)$/;
    const embeddedFormatUrl = /^https:\/\/www\.youtube\.com\/embed\/(\S+)$/;
    const linkFormatUrl = /^https:\/\/www\.youtube\.com\/watch\?v\=(\S+)$/;

    const shareMatch = sharedFormatUrl.exec(videoURL);
    const embedMatch = embeddedFormatUrl.exec(videoURL);
    const linkMatch = linkFormatUrl.exec(videoURL);

    if (shareMatch) {
      return this.sanitizer.bypassSecurityTrustResourceUrl(
        `https://www.youtube.com/embed/${shareMatch[1]}?rel=0&showinfo=0&controls=0&modestbranding=1`
      );
    } else if (embedMatch) {
      videoURL = videoURL + '?rel=0&showinfo=0&controls=0&modestbranding=1';
      return this.sanitizer.bypassSecurityTrustResourceUrl(videoURL);
    } else if (linkMatch) {
      return this.sanitizer.bypassSecurityTrustResourceUrl(
        `https://www.youtube.com/embed/${linkMatch[1].replace('&', '?')}?rel=0&showinfo=0&controls=0&modestbranding=1`
      );
    } else {
      return '';
    }
  }

  getBlogUrl(item: any): string {
    var queryParams = this.productService.getBlogViewNode(item);
    return `/blog-details/${item.nid}/${queryParams}`;
  }

  viewBlog(item: any) {
    var queryParams = this.productService.getBlogViewNode(item);
    var url = '/blog-details/' + item.nid + '/' + queryParams;
    window.open(url, '_blank');
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  imageClick(index: number) {
    this.activeIndex = index;
    this.displayCustom = true;
  }

  cimageClick(index: number) {
    this.activeIndexc = index;
    this.displayCustomc = true;
  }

  imageItemClick(index: number) {
    this.imageActiveIndex = index;
    this.imageDisplayCustom = true;
  }

  galleryItemClick(index: number) {
    this.galleryActiveIndex = index;
    this.galleryDisplayCustom = true;
  }
}
